module.exports = __webpack_public_path__ + "static/report-6b916465a4b8e972f44a3ea35cb1ea6e.png";